import { HStack, SearchInput } from '@genial/components';
import { useBreakpointValue } from '@genial/utils';
import { RouteProp, useRoute } from '@react-navigation/native';
import { Box, Spacer } from 'native-base';
import { useMemo } from 'react';

import { SignedInRootStackParamList } from '../../../../routes/types';

export declare namespace CustomerSearchBarTypes {
  export type Props = {
    isLoading: boolean;
    onSearch: (searchTerm: string) => void;
    onClear: () => void;
  };
}

export const CustomerSearchBar = ({ isLoading, onSearch, onClear }) => {
  const { params } = useRoute<RouteProp<SignedInRootStackParamList, 'Customers'>>();
  const placeholder = 'Pesquise por nome, conta ou CPF';

  const CustomerSearchBarFull = useMemo(
    () => (
      <>
        <HStack alignItems="center" marginX="inline.xxxs">
          <SearchInput
            isLoading={isLoading}
            onSearch={onSearch}
            onClear={onClear}
            placeholder={placeholder}
            initialSearch={params?.search}
          />
          <Spacer />
        </HStack>
      </>
    ),
    [isLoading, onClear, onSearch, params]
  );

  const CustomerSearchBarSmall = useMemo(
    () => (
      <Box>
        <SearchInput
          isLoading={isLoading}
          onSearch={onSearch}
          onClear={onClear}
          isMobile
          placeholder={placeholder}
          initialSearch={params?.search}
        />
      </Box>
    ),
    [isLoading, onClear, onSearch, params]
  );

  const CustomerSearchBarResponsive = useBreakpointValue({
    base: CustomerSearchBarSmall,
    sm: CustomerSearchBarFull,
  });

  return CustomerSearchBarResponsive;
};
